import { GenericObject, Tag, Topic, copyFields } from '@synergy/models';

import { Account } from './account';

export class Contact {
    public id!: number;
    public fullName!: string;
    public positionName?: string;
    public accounts!: Account[];
    public isLocked!: boolean;
    public isDeleted!: boolean;
    public tags?: Tag[];
    public isMainContact?: boolean;
    public phone?: string;
    public phones?: [{ type: string; number: string }];
    public email?: string;
    public emails?: [{ type: string; email: string }];
    public topics?: Topic[];

    public static fromPlainObject(object: GenericObject): Contact {
        const contact = new Contact();

        copyFields(object, contact);

        if (object['accounts']) {
            contact.accounts = object['accounts'].map(Account.fromPlainObject);
        }

        return contact;
    }

    public getTags(maxLength?: number) {
        let tags = (this.tags && this.tags.map(tag => tag.name).join(' ')) || '';
        if (maxLength && tags.length > maxLength) {
            tags = tags.substring(0, maxLength) + '...';
        }
        return tags;
    }
}
